import React, { useEffect, useRef, useState } from 'react';
import { PUAN_SECENEKLERI, puanSecimListesi, puanSecimOzeti } from '../../lib/zorlukSeviye';

// Puan seviyesi ÇOKLU seçimi (2026-10-26, kullanıcı isteği "her seviye checkbox ile seçilebilsin,
// genel olarak kullanılsın"): düğme + açılır checkbox listesi. Panel liste süzgeci (YKS ve LGS),
// müşteri paneli ve Basım (Soru ekle, Konu Testi / Genel Deneme puanı) aynı bileşeni kullanır.
// `deger`: değer dizisi ('yok', '2-4' …); `onDegis(dizi)` seçenek sırasıyla döner. Boş = tümü.
export default function PuanSecici({
  deger, onDegis, secenekler = PUAN_SECENEKLERI, etiket = 'Puan', ariaLabel = 'Puan filtresi',
  title = 'Puan seviyesi — birden çok seviye seçilebilir', dugmeSinifi = null,
}) {
  const [acik, setAcik] = useState(false);
  const kutu = useRef(null);
  const secili = new Set(puanSecimListesi(deger));
  const aktif = secili.size > 0;

  useEffect(() => {
    if (!acik) return undefined;
    const disari = (e) => { if (kutu.current && !kutu.current.contains(e.target)) setAcik(false); };
    const kacis = (e) => { if (e.key === 'Escape') setAcik(false); };
    document.addEventListener('mousedown', disari);
    document.addEventListener('keydown', kacis);
    return () => { document.removeEventListener('mousedown', disari); document.removeEventListener('keydown', kacis); };
  }, [acik]);

  const degistir = (v) => {
    const yeni = new Set(secili);
    if (yeni.has(v)) yeni.delete(v); else yeni.add(v);
    onDegis(secenekler.map((o) => o.value).filter((x) => yeni.has(x)));
  };

  const sinif = dugmeSinifi ? dugmeSinifi(aktif)
    : `px-2 py-1.5 rounded border text-xs ${aktif ? 'border-blue-400 bg-blue-50 text-blue-800 font-semibold' : 'border-gray-300 bg-white text-gray-700'}`;

  return (
    <div className="relative inline-block" ref={kutu} data-puan-secici>
      <button type="button" aria-label={ariaLabel} aria-haspopup="true" aria-expanded={acik} title={title}
        onClick={() => setAcik((a) => !a)} className={sinif}>
        {etiket}: {puanSecimOzeti(deger, secenekler)} ▾
      </button>
      {acik && (
        <div role="group" aria-label={`${etiket} seviyeleri`}
          className="absolute z-30 mt-1 min-w-[11rem] rounded border border-gray-200 bg-white p-1.5 shadow-lg">
          <label className="flex cursor-pointer items-center gap-2 rounded px-1.5 py-1 text-xs hover:bg-gray-50">
            <input type="checkbox" checked={!aktif} onChange={() => onDegis([])} data-puan-tumu />
            <span className="font-semibold">Tümü</span>
          </label>
          <div className="my-1 h-px bg-gray-100" />
          {secenekler.map((o) => (
            <label key={o.value} className="flex cursor-pointer items-center gap-2 rounded px-1.5 py-1 text-xs hover:bg-gray-50">
              <input type="checkbox" value={o.value} checked={secili.has(o.value)} onChange={() => degistir(o.value)} data-puan-secenek={o.value} />
              <span>{o.label}</span>
            </label>
          ))}
        </div>
      )}
    </div>
  );
}
